import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_THEME } from "../theme/theme";
import BannerCarousel from "../components/banner-carousel";
import HeaderWithProfile from "../components/header-with-profile";
import BottomNav from "../components/bottom-menu";
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from "../utils/api";
import Bmnemonic_PNG from "../assets/image/Bmnemonic_PNG.png"

const serviceIcons = {
    phone: (color) => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
            <line x1="12" y1="18" x2="12.01" y2="18" />
        </svg>
    ),
    dth: (color) => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 3a8 8 0 0 0-8 8" />
            <path d="M14 7a4 4 0 0 0-4 4" />
            <circle cx="14" cy="11" r="1.5" fill={color} stroke="none" />
            <rect x="4" y="17" width="16" height="4" rx="1" />
            <circle cx="7" cy="19" r="0.5" fill={color} stroke="none" />
            <circle cx="10" cy="19" r="0.5" fill={color} stroke="none" />
        </svg>
    ),
    electricity: (color) => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
        </svg>
    ),
    fastag: (color) => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
            <path d="M7 15h10" />
            <circle cx="7" cy="15" r="0.5" fill={color} />
            <path d="M18 10V7" />
        </svg>
    ),
    postpaid: (color) => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2" />
            <line x1="9" y1="18" x2="15" y2="18" />
            <path d="M12 6h4" />
            <path d="M12 10h4" />
            <path d="M12 14h4" />
            <path d="M8 6h.01" />
            <path d="M8 10h.01" />
            <path d="M8 14h.01" />
        </svg>
    ),
    gift: (color) => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 12 20 22 4 22 4 12" />
            <rect x="2" y="7" width="20" height="5" />
            <line x1="12" y1="22" x2="12" y2="7" />
            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
        </svg>
    ),
    // Remove billpay from here since we'll handle it separately
};

const services = [
    { label: "Mobile", category: "", icon: "phone", path: "/mobile-recharge" },
    { label: "DTH", category: "", icon: "dth", path: "/dth-recharge" },
    { label: "Electricity", category: "Electricity", icon: "electricity", path: "/operator" },
    { label: "FASTag", category: "Fastag", icon: "fastag", path: "/operator" },
    { label: "Postpaid", category: "Postpaid", icon: "postpaid", path: "/operator" },
    { label: "Redeem", category: "", icon: "gift", path: "/redeem-code-recharge" },
    { label: "Billpay", category: "", icon: "png", path: "/operator" }, // Changed icon to "png"
];

const top_services = [
    { label: "Mobile", category: "", icon: "phone", path: "/mobile-recharge" },
    { label: "DTH", category: "", icon: "dth", path: "/dth-recharge" },
    /*
    { label: "Electricity", category: "Electricity", icon: "electricity", path: "/operator" },
    { label: "FASTag", category: "Fastag", icon: "fastag", path: "/operator" }
    */
];

// Helper functions for banner caching
const BANNER_CACHE_KEY = 'banner_data';
const BANNER_TIMESTAMP_KEY = 'banner_timestamp';
const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

const getCachedBanner = () => {
    try {
        const cachedData = localStorage.getItem(BANNER_CACHE_KEY);
        const timestamp = localStorage.getItem(BANNER_TIMESTAMP_KEY);

        if (cachedData && timestamp) {
            const now = Date.now();
            const cacheAge = now - parseInt(timestamp);

            if (cacheAge < CACHE_DURATION) {
                return JSON.parse(cachedData);
            }
        }
        return null;
    } catch (error) {
        console.error('Error reading banner cache:', error);
        return null;
    }
};

const setCachedBanner = (bannerData) => {
    try {
        localStorage.setItem(BANNER_CACHE_KEY, JSON.stringify(bannerData));
        localStorage.setItem(BANNER_TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
        console.error('Error saving banner cache:', error);
    }
};

function Home() {
    const navigate = useNavigate();
    const [hoveredCard, setHoveredCard] = useState(null);
    const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");
    const [bannerData, setBannerData] = useState(null);


    useEffect(() => {
        const getDeviceInfo = () => {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        type: "GET_DEVICE_INFO"
                    })
                );
            }
        };
        getDeviceInfo();
    }, [])


    useEffect(() => {
        const fetchBalance = async () => {
            try {
                const result = await apiCall(
                    "balance",
                    {},
                    true
                );
                if (result.status === true) {
                    setBalance(result.data.balance);
                    localStorage.setItem("balance", result.data.balance)
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        }

        const fetchBanner = async () => {
            // Check for cached banner first
            const cachedBanner = getCachedBanner();

            if (cachedBanner) {
                console.log('Using cached banner data');
                setBannerData(cachedBanner);
                return;
            }

            // Fetch new banner if cache is expired or doesn't exist
            try {
                const result = await apiCall(
                    "banner",
                    {},
                    true
                );
                if (result.status === true && result.banner) {
                    setBannerData(result.banner);
                    setCachedBanner(result.banner);
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        }

        fetchBalance();
        fetchBanner();
    }, [])

    // Helper function to render icon based on type
    const renderIcon = (service, index) => {
        if (service.icon === 'png') {
            // Render PNG for billpay
            return (
                <img
                    src={Bmnemonic_PNG}
                    alt="Billpay"
                    style={{
                        width: 26,
                        height: 26,
                        objectFit: 'contain'
                    }}
                />
            );
        } else {
            // Render SVG icons for others
            return serviceIcons[service.icon](APP_THEME.primaryColor);
        }
    };

    return (
        <>
            <HeaderWithProfile />
            <div className="mb-24">
                {/* Banner Carousel */}
                <BannerCarousel bannerData={bannerData} />

                {/* Wallet Card */}
                <div
                    className="mx-4 mt-4  rounded-t-2xl flex items-center justify-between py-4"
                    style={{
                        background: APP_THEME.bgColor,
                        boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                        border: `1px solid ${APP_THEME.borderColor}`,
                    }}
                >
                    <div className="flex items-center gap-2 pl-4">
                        {/* Wallet Icon - Fixed & Larger */}
                        <div
                            className="rounded-full p-2.5 flex items-center justify-center bg-gray-200"
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#323DB8"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <rect x="2" y="5" width="20" height="16" rx="2" ry="2" />
                                <path d="M16 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
                                <path d="M2 9h18" />
                                <path d="M6 9V7" />
                            </svg>
                        </div>

                        <div>
                            <div className="text-xs font-medium tracking-wider text-gray-500">
                                Wallet Balance
                            </div>
                            <div className="text-sm font-bold text-gray-700">
                                ₹{balance}
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => navigate("/add-money")}
                        className="px-5 py-2 text-xs font-semibold rounded-l-full transition-all duration-200 hover:scale-105 active:scale-95 whitespace-nowrap"
                        style={{
                            background: APP_THEME.primaryColor,
                            color: "#FFFFFF",
                            fontFamily: APP_THEME.fontFamily,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                    >
                        + Add Money
                    </button>
                </div>


                {/* Top Services Section */}
                <div
                    className="rounded-b-xl p-4 m-4 mt-0"
                    style={{
                        background: APP_THEME.bgColor,
                        boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                        border: `1px solid ${APP_THEME.borderColor}`,
                    }}
                >
                    <div className="grid grid-cols-4 md:grid-cols-6 gap-4 justify-items-center items-center">
                        {top_services.map((service, index) => (
                            <div
                                key={index}
                                onClick={() => navigate(service.path, { state: { category: service.category } })}
                                className="flex flex-col items-center gap-2.5 cursor-pointer w-full"
                            >
                                <div
                                    onMouseEnter={() => setHoveredCard(index)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    className="w-14 h-14 rounded-xl flex items-center justify-center"
                                    style={{
                                        background: APP_THEME.primaryColor,
                                        border: `1px solid ${hoveredCard === index ? APP_THEME.primaryLight : APP_THEME.borderColor}`,
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                                    }}
                                >
                                    <div style={{ filter: "brightness(0) invert(1)" }}>
                                        {renderIcon(service, index)}
                                    </div>
                                </div>
                                <span
                                    className="text-[0.6875rem] font-medium text-center leading-tight"
                                    style={{
                                        color: APP_THEME.textSecondary,
                                        fontFamily: APP_THEME.fontFamily,
                                    }}
                                >
                                    {service.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                
      {/*
                <div
                    className="rounded-xl p-4 m-4"
                    style={{
                        background: APP_THEME.bgColor,
                        boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                        border: `1px solid ${APP_THEME.borderColor}`,
                    }}
                >
                    <div className="grid grid-cols-4 md:grid-cols-6 gap-4 justify-items-center items-center">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                onClick={() => navigate(service.path, { state: { category: service.category } })}
                                className="flex flex-col items-center gap-2.5 cursor-pointer w-full"
                            >
                                <div
                                    onMouseEnter={() => setHoveredCard(index)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    className="w-14 h-14 rounded-xl flex items-center justify-center"
                                    style={{
                                        background: hoveredCard === index ? APP_THEME.primaryLight : APP_THEME.surfaceColor,
                                        border: `1px solid ${hoveredCard === index ? APP_THEME.primaryColor : APP_THEME.borderColor}`,
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                                    }}
                                >
                                    {renderIcon(service, index)}
                                </div>
                                <span
                                    className="text-[0.6875rem] font-medium text-center leading-tight"
                                    style={{
                                        color: APP_THEME.textSecondary,
                                        fontFamily: APP_THEME.fontFamily,
                                    }}
                                >
                                    {service.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                */}
                

                <div
                    onClick={() => navigate("/support-center")}
                    className="relative rounded-xl p-4 m-4 flex items-center cursor-pointer transition-all duration-200 active:scale-98 mb-6 overflow-hidden"
                    style={{
                        background: APP_THEME.surfaceColor,
                        border: `1px solid ${APP_THEME.borderColor}`,
                    }}
                >
                    <div
                        className="absolute top-0 right-0 text-[0.5625rem] font-extrabold text-white uppercase tracking-wide px-2.5 py-1"
                        style={{
                            background: APP_THEME.primaryColor,
                            borderBottomLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                            fontFamily: APP_THEME.fontFamily,
                        }}
                    >
                        Support
                    </div>
                    <div className="flex items-center gap-3.5">
                        <div
                            className="w-[2.625rem] h-[2.625rem] rounded-xl flex items-center justify-center"
                            style={{
                                background: `${APP_THEME.primaryColor}15`,
                            }}
                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.primaryColor} strokeWidth="2" strokeLinecap="round">
                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                            </svg>
                        </div>
                        <div>
                            <div className="text-sm font-bold" style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}>
                                Need Help?
                            </div>
                            <div className="text-[0.6875rem] mt-0.5" style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}>
                                Chat with our support team
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster position="bottom-center" />
            <BottomNav />

            <style>
                {`
                .active\\:scale-98:active {
                    transform: scale(0.98);
                }
                
                .active\\:scale-95:active {
                    transform: scale(0.95);
                }
                `}
            </style>
        </>
    );
}

export default Home;